import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import type { EmergencyContactDetails } from "@freightsimple/generated-dashboard-openapi-client/models/EmergencyContactDetails";

import type { EmergencyContactDetailsErrors } from "../Validators/dangerousGoodsErrorMessagesForEmergencyContact";
import { DangerousGoodsEmergencyContactInput } from "../Inputs/DangerousGoodsEmergencyContactInput";

interface DangerousGoodsComponentProps {
  emergencyContactDetails: EmergencyContactDetails;
  onUpdateEmergencyContactDetails: (updates: EmergencyContactDetails) => void;
  forceValidation: boolean;
  emergencyContactDetailsErrors: EmergencyContactDetailsErrors;
  // True when the shipment touches Canada — adds the TDG-responsible and ERAP fields.
  showCanadianTdgFields: boolean;
}

export function DangerousGoodsComponent(props: DangerousGoodsComponentProps) {
  const {
    emergencyContactDetails,
    onUpdateEmergencyContactDetails,
    forceValidation,
    emergencyContactDetailsErrors,
    showCanadianTdgFields,
  } = props;

  return (
    <Panel collapseOnNarrow>
      <DangerousGoodsEmergencyContactInput
        emergencyContactDetails={emergencyContactDetails}
        onUpdateEmergencyContactDetails={onUpdateEmergencyContactDetails}
        forceValidation={forceValidation}
        errorMessages={emergencyContactDetailsErrors}
        showCanadianTdgFields={showCanadianTdgFields}
      />
    </Panel>
  );
}
